import { Injectable } from '@angular/core';
import { AppIcons, IIcons } from '@datachain/ui-sdk/components/dc-icon';

export enum ComponentIcons {
	Access = 'adbComponent:access',
	Admin = 'adbComponent:admin',
	Column = 'adbComponent:column',
	Data = 'adbComponent:data',
	Depersist = 'adbComponent:depersist',
	Error = 'adbComponent:error',
	Exposition = 'adbComponent:exposition',
	Filter = 'adbComponent:filter',
	FilterOff = 'adbComponent:filterOff',
	FolderInfo = 'adbComponent:folder-info',
	Group = 'adbComponent:group',
	Help = 'adbComponent:help',
	Info = 'adbComponent:info',
	Member = 'adbComponent:member',
	Persist = 'adbComponent:persist',
	Profile = 'adbComponent:profile',
	Project = 'adbComponent:project',
	PublicEndpointMetadata = 'adbComponent:public-endpoint-metadata',
	Success = 'adbComponent:success',
	User = 'adbComponent:user',
	View = 'adbComponent:view',
	Warning = 'adbComponent:warning',
}

@Injectable()
export class AppUiComponentIcons extends AppIcons {
	private readonly path = './src/img';
	protected namespace = 'adbComponent';
	protected icons: IIcons = {
		[ComponentIcons.Admin]: `${this.path}/project/manage_accounts_48dp_000000_FILL0_wght300_GRAD0_opsz48.svg`,
		[ComponentIcons.Access]: `${this.path}/common/key_48dp_FILL1_wght400_GRAD0_opsz48.svg`,
		[ComponentIcons.Column]: `${this.path}/common/view_column_FILL1_wght300_GRAD0_opsz48.svg`,
		[ComponentIcons.Data]: `${this.path}/common/table_rows_narrow_48dp_FILL1_wght300_GRAD0_opsz48.svg`,
		[ComponentIcons.Depersist]: `${this.path}/datablock/disc-drive-solid.svg`,
		[ComponentIcons.Error]: `${this.path}/common/cancel_48dp_FILL1_wght300_GRAD0_opsz48.svg`,
		[ComponentIcons.Exposition]: `${this.path}/datablock/icon-api-config.svg`,
		[ComponentIcons.Filter]: `${this.path}/common/filter_alt_FILL1_wght300_GRAD0_opsz48.svg`,
		[ComponentIcons.FilterOff]: `${this.path}/common/filter_alt_off_48dp.svg`,
		[ComponentIcons.FolderInfo]: `${this.path}/project/folder_info_48dp_000000_FILL0_wght300_GRAD0_opsz48.svg`,
		[ComponentIcons.Group]: `${this.path}/common/groups_FILL1_wght300_GRAD0_opsz48.svg`,
		[ComponentIcons.Help]: `${this.path}/common/live_help_48dp_5F6368_FILL1_wght400_GRAD0_opsz48.svg`,
		[ComponentIcons.Info]: `${this.path}/project/info_48dp_000000_FILL0_wght400_GRAD0_opsz48.svg`,
		[ComponentIcons.Member]: `${this.path}/project/group_48dp_000000_FILL0_wght300_GRAD0_opsz48.svg`,
		[ComponentIcons.Persist]: `${this.path}/datablock/disc-drive.svg`,
		[ComponentIcons.Profile]: `${this.path}/common/profile_48dp_5F6368_FILL1_wght400_GRAD0_opsz48.svg`,
		[ComponentIcons.Project]: `${this.path}/common/project_48dp_FILL0_wght400_GRAD0_opsz48.svg`,
		[ComponentIcons.PublicEndpointMetadata]: `${this.path}/common/text_ad_24dp_FILL0_wght400_GRAD0_opsz24.svg`,
		[ComponentIcons.Success]: `${this.path}/common/check_circle_48dp_FILL1_wght300_GRAD0_opsz48.svg`,
		[ComponentIcons.User]: `${this.path}/common/person_FILL1_wght300_GRAD0_opsz48.svg`,
		[ComponentIcons.View]: `${this.path}/common/visibility_24dp_FILL0_wght400_GRAD0_opsz24.svg`,
		[ComponentIcons.Warning]: `${this.path}/common/warning_48dp_FILL1_wght400_GRAD0_opsz48.svg`,
	};
}
